"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSetActiveHighlightSearchPatternDto = instanceOfSetActiveHighlightSearchPatternDto;
exports.SetActiveHighlightSearchPatternDtoFromJSON = SetActiveHighlightSearchPatternDtoFromJSON;
exports.SetActiveHighlightSearchPatternDtoFromJSONTyped = SetActiveHighlightSearchPatternDtoFromJSONTyped;
exports.SetActiveHighlightSearchPatternDtoToJSON = SetActiveHighlightSearchPatternDtoToJSON;
exports.SetActiveHighlightSearchPatternDtoToJSONTyped = SetActiveHighlightSearchPatternDtoToJSONTyped;
/**
 * Check if a given object implements the SetActiveHighlightSearchPatternDto interface.
 */
function instanceOfSetActiveHighlightSearchPatternDto(value) {
    if (!('patternId' in value) || value['patternId'] === undefined)
        return false;
    return true;
}
function SetActiveHighlightSearchPatternDtoFromJSON(json) {
    return SetActiveHighlightSearchPatternDtoFromJSONTyped(json, false);
}
function SetActiveHighlightSearchPatternDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'patternId': json['patternId'],
    };
}
function SetActiveHighlightSearchPatternDtoToJSON(json) {
    return SetActiveHighlightSearchPatternDtoToJSONTyped(json, false);
}
function SetActiveHighlightSearchPatternDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'patternId': value['patternId'],
    };
}
